import { ActivityName } from "../types";

export type TAlertType = "red" | "yellow" | "green";

export const ALERT_TYPE = {
    RED: "red" as const,
    YELLOW: "yellow" as const,
    GREEN: "green" as const
}

export const ALERT_TYPE_COLORS = {
    [ALERT_TYPE.RED]: {
        bg: "bg-error-500 border-error-500",
        text: "text-white",
    },
    [ALERT_TYPE.YELLOW]: {
        bg: "bg-warning-500 border-warning-500",
        text: "text-black",
    },
    [ALERT_TYPE.GREEN]: {
        bg: "bg-secondary-600 border-secondary-300",
        text: "text-white",
    }
}

export const ALERT_TYPE_TITLES = {
    [ALERT_TYPE.RED]: "measurement.alert.title",
    [ALERT_TYPE.YELLOW]: "measurement.warning.title",
    [ALERT_TYPE.GREEN]: "measurement.normal.title",
}

export const ALERT_TYPE_DESCRIPTIONS = {
    [ALERT_TYPE.RED]: "measurement.alert.description",
    [ALERT_TYPE.YELLOW]: "measurement.warning.description",
    [ALERT_TYPE.GREEN]: "measurement.normal.description",
}

export const ACTIVITY_CUSTOM_TRANSLATIONS: Partial<Record<ActivityName, { title: string; description: string }>> = {
    [ActivityName.WEIGHT]: {
        title: 'measurement.custom.weight.title',
        description: 'measurement.custom.weight.description',
    },
};
